export default "__VITE_ASSET__MDsVHsGR__"